module.exports = __webpack_public_path__ + "static/media/banner_home.ba88a066.png";